import plans from '../plans/plans.json';

const planNames = Object.keys(plans).filter((key) => key !== 'default');

export function slugifyPlanName(planName = '') {
    return `${planName}`
        .toLowerCase()
        .replace(/&/g, ' and ')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
}

export function buildPlansPath(planName = '') {
    if (!planName) return '/plans';
    return `/plans/${slugifyPlanName(planName)}`;
}

export function resolvePlanName(planIdentifier = '') {
    const decoded = decodeURIComponent(`${planIdentifier || ''}`).trim();
    if (!decoded) return null;

    if (plans[decoded]) return decoded;

    const slug = slugifyPlanName(decoded);
    const matched = planNames.find((name) => slugifyPlanName(name) === slug);
    return matched || decoded;
}
